import type { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

export const useSitesListStyles = makeStyles((theme: Theme) => ({
    sitesListDetailPanelMainContent: {
        flexGrow: 1,
        alignSelf: "stretch",
    },
    sitesListDetailPanelCameraImagesContainer: {
        margin: theme.spacing(1),
    },
    sitesListHeader: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    sitesListHeaderPrimaryRow: {
        alignItems: "baseline",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(3),
    },
    verticalTab: {
        marginBottom: 0,
    },
    sitesList__showEndedSites: {
        marginTop: theme.spacing(0.5),
        marginRight: theme.spacing(1),
    },
}));
